import AuthProviderItem from "./auth-provider-item";

export default class FacebookAuthItem extends AuthProviderItem {
  constructor(menu) {
    super('facebook', menu);
  }

  get template() {
    return `
      <button>
        <svg width="44" height="44" viewBox="0 0 44.674 45.032"><ellipse cx="22.844" cy="22.45" rx="16.765" ry="18.784" fill="#FFF"></ellipse><path fill="#3D5B9A" d="M22.337,0c12.336,0,22.337,10.081,22.337,22.516c0,12.436-10.001,22.516-22.337,22.516C10.001,45.032,0,34.952,0,22.516C0,10.081,10.001,0,22.337,0L22.337,0z M19.077,22.465c0.065,0.082,0.029,0.655,0.029,0.762l0.003,12.085h5.226c0.031-3.181,0.001-6.445,0.001-9.641c0-0.046-0.01-3.096,0.004-3.16c0.01-0.042,0.011-0.036,0.022-0.054c0.007,0.001,3.325,0.027,3.441-0.001l0.058-0.017l0.459-4.411l-3.967,0c-0.015-0.651,0.003-1.321,0.004-1.974c0-0.597-0.014-1.333,0.34-1.661l3.603-0.363l-0.006-4.425c-0.682-0.041-1.49-0.004-2.186-0.004c-0.724,0-1.457-0.015-2.168,0.033c-1.357,0.09-2.452,0.495-3.245,1.172c-1.148,1.846-1.592,0.261-1.601,7.223l-2.626,0.001l0.005,4.431L19.077,22.465L19.077,22.465z"></path></svg>
      </button>
    `;
  }
}
